module.exports = __webpack_public_path__ + "img/wxf.7cf0e443.png";